import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import GenericTable from "components/CRPComponents/Tables/GenericTable";
import LinkCell from "components/CRPComponents/Tables/components/LinkCell";
import DefaultCell from "components/CRPComponents/Tables/components/DefaultCell";
import { GET_ALL_QUERY, GetAllGql, responseGetAllKey } from "./queries/getAll";
import { ApiWithSetData, path } from "./hooks/types";
import { path as userPath } from "../config/AdminUser/hooks/types";

function List() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <GenericTable<GetAllGql>
        initialVariables={{
          page: 1,
          perPage: 10,
          search: null,
        }}
        path={path}
        query={GET_ALL_QUERY}
        formatRows={(data) => data[responseGetAllKey].items}
        formatPagination={(data) => data[responseGetAllKey].paginationInfo}
        ApiSetData={ApiWithSetData}
        useDefaultFilter={false}
        columnsTable={[
          {
            Header: "Id",
            accessor: "id",
            Cell: ({ value }: any) => <LinkCell href={`${path}/${value}`} value={value} />,
          },
          {
            Header: "Origem",
            accessor: "origin",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Categoria",
            accessor: "category",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Data",
            accessor: "createdAt",
            Cell: ({ value }: any) => (
              <DefaultCell value={new Date(value)?.toLocaleString("pt-BR")} />
            ),
          },
          {
            Header: "Id Usuário",
            accessor: "userId",
            Cell: ({ value }: any) => (
              <LinkCell href={!value ? "" : `${userPath}/${value}`} value={value || ""} />
            ),
          },
        ]}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default List;
